export class DecimalOverflowError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, DecimalOverflowError.prototype);
    this.name = "DecimalOverflowError";
  }
}
